import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { EDTFTypeTranslationsPartial } from '../entities/edtf-type-translations.entity';
import { ShFormEDTFBaseComponent } from '../base-simple/form-edtf-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormEDTFComplexBaseComponent } from '../base-complex/form-edtf-complex-base.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-edtf',
    templateUrl: './form-edtf.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormEDTFComplexBaseComponent, ReactiveFormsModule, NgClass, ShFormEDTFBaseComponent, AsyncPipe]
})
export class ShFormEDTFComponent extends ShBaseFormComponent implements OnInit {
    @Input() typePlaceholderMsg!: string;
    @Input() typeLabel!: string;
    @Input() valueLabel!: string;
    @Input() formatExamplePrefix!: string;
    @Input() invalidFormatMsg!: string;
    @Input() unrecognizedFormatMsg!: string;
    @Input() i18n!: EDTFTypeTranslationsPartial;

    ngOnInit(): void {
        super.ngOnInit();
    }
}
